

























































































































































































































































import Vue from "vue";
import { Collapse, Icon } from "ant-design-vue";

export default Vue.extend({
  name: "Faq",
  data() {
    return {
      collapseProps: {
        accordion: true,
        bordered: false,
        expandIconPosition: "right"
      }
    };
  },
  components: {
    [Collapse.name]: Collapse,
    [Collapse.Panel.name]: Collapse.Panel,
    [Icon.name]: Icon
  }
});
